import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-go",
  "use": "arrow-go-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol viewBox=\"0 0 25 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-go\"><path fill=\"currentColor\" d=\"m11.047 15.59 1.41 1.41 5-5-5-5-1.41 1.41 2.58 2.59h-9.67v2h9.67l-2.58 2.59ZM19.957 3h-14a2 2 0 0 0-2 2v4h2V5h14v14h-14v-4h-2v4a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol